var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_49",
    "data-name": "Layer 49"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#2488ff",
    r: 29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#006df0",
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.145 3a29.023 29.023 0 0 1 .69 4.017 25 25 0 1 1 -24.911 31.712 29.35 29.35 0 0 1 -3.924.271c-.049 0-.1 0-.145 0a29 29 0 1 0 28.29-36z",
    fill: "#006df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 57a25 25 0 0 0 .835-49.979 29.013 29.013 0 0 1 .165 2.979 29 29 0 0 1 -25.076 28.729 25 25 0 0 0 24.076 18.271z",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bddbff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.97 36-12.97 4.97-12.97-4.97 12.97 14.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.11 32.71-11.11-19.68-11.11 19.68 11.11 4.26z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.3adb2e0fce5d2a76f2a429cebf1698cf.svg";
export { ForwardRef as ReactComponent };